import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/button';
import pathfinder from '@fiverr-private/pathfinder';
import { sendBigQueryEvent } from '../../../utils/bigQuery';
import { AppI18n } from '../../../i18n';
import { TOP_NAV_SOURCE } from '../../../constants';

const LOCALE_JOB_PAGE_LOCALES = ['de-DE', 'es', 'fr-FR'];

interface GuestBecomeSellerNavItemProps {
    copyKey?: 'become_seller' | 'freelance_on_fiverr';
}

export const GuestBecomeSellerNavItem = ({ copyKey = 'become_seller' }: GuestBecomeSellerNavItemProps) => {
    const { locale } = getContext();

    const path = LOCALE_JOB_PAGE_LOCALES.includes(locale)
        ? pathfinder('seller_job_page', { hub_id: 'freelance-jobs' }, { query: { source: TOP_NAV_SOURCE } }).replace(
              /\)/g,
              ''
          ) // pathfinder bug workaround: https://github.com/fiverr/pathfinder/issues/45
        : pathfinder('start_selling', {}, { query: { source: TOP_NAV_SOURCE } });

    const handleClick = () => {
        sendBigQueryEvent({ group: 'header_clicks', type: 'clicked_header.start_selling' });
    };

    return (
        <Button variant="ghost" href={path} rel="nofollow" onClick={handleClick}>
            <AppI18n k={copyKey} />
        </Button>
    );
};
